import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import JobUpdateDialog from '../../dialogs/job.update';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const job = useConnect('job.byId', {
    id: config.params.jobId
  });

  if (job.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <JobUpdateDialog
      job={job}
      onCancel={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['job'] });
      }}
    />
  );
};
